import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getStaMaintenanceRecord } from "@/api/api-operation-service";
import piSiteChangeRecord from "../pi-site-change-record/pi-site-change-record.vue";
let PiSiteSteps = class PiSiteSteps extends Vue {
    constructor() {
        super(...arguments);
        this.recordList = [];
    }
    async getStaMaintenanceRecord() {
        const ret = await getStaMaintenanceRecord({
            staPkId: this.staPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.recordList = ret.data;
        }
    }
    mounted() {
        this.getStaMaintenanceRecord();
    }
};
__decorate([
    Prop({ default: "" })
], PiSiteSteps.prototype, "staPkId", void 0);
PiSiteSteps = __decorate([
    Component({
        components: {
            "pi-site-change-record": piSiteChangeRecord,
        },
    })
], PiSiteSteps);
export default PiSiteSteps;
